const getters = {
  userInfo: (state) => state.user.userInfo,
  tenant: (state) => state.tenant.tenantInfo,
  
};
export default getters;
